export default "__VITE_ASSET__BRxPczud__"